import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const WaivePromoterFundModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // form fields
  waivePromoterFund, onWaivePromoterFundChange, waivePromoterFundError, setWaivePromoterFundError, booleanList
}) =>
  <ModalFormUI
    context={context}
    titleLabel=''
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='wpf'
      label='Waive promoter fund' optionList={booleanList}
      value={waivePromoterFund} onChange={onWaivePromoterFundChange}
      error={waivePromoterFundError} setError={setWaivePromoterFundError}
    />
  </ModalFormUI>

export default WaivePromoterFundModalUI
